/**
 * Route for `email-in-app-webhook-notification-channels`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EmailInAppWebhookNotificationChannelsPage } from "../features/email-in-app-webhook-notification-channels/EmailInAppWebhookNotificationChannelsPage";

export const emailInAppWebhookNotificationChannelsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/email-in-app-webhook-notification-channels",
	component: EmailInAppWebhookNotificationChannelsPage,
});

export default emailInAppWebhookNotificationChannelsRoute;
